import { MarketCodes } from '@prisjakt/web-app-config/types/market';

// Formats number with thousands separator
export default function formatNumber(count: number, marketCode: MarketCodes) {
  const countString = count.toString();
  if (countString.length <= 3) return count;

  switch (marketCode) {
    case 'se':
    case 'no':
    case 'dk':
    case 'fi':
    case 'fr':
      return countString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    case 'gb':
      return count.toLocaleString();
    default:
      return count.toLocaleString();
  }
}
